export const fi = {
    LEFT: 'Vasemmalle: Siirry edelliseen päivä.',
    RIGHT: 'Oikea: Siirry seuraavaan päivään.',
    DOWN: 'Alaspäin: Siirry seuraavalle riville.',
    UP: 'Ylös: Siirry edelliseen rivin.',
    PGUP: 'PgUp: Siirtää edelliseen kuukauteen.',
    PGDOWN: 'PgDown: Siirtää seuraavaan kuukauteen.',
    HOME: 'Home: Siirry edelliseen vuoteen.',
    END: 'End: Siirry seuraavalle vuodelle.',
    ESC: 'Esc/Tänään/Sulje: sulje kalenteri.',
    TITLE: 'Keyboard Ohjeita'
};
